module.exports = __webpack_public_path__ + "static/img/ca02.f949969.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/ceges-ajandektargyak/ca02.jpg
// module id = 542
// module chunks = 0